<template>
    <div class="h-screen">
      <div class="h-2/3">
        <div class="h-full flex justify-center items-center">
          <div>
            <div class="flex justify-center items-center">
              <div>
                <img src="../assets/img/logo.png" />
                <div>考勤排班数据平台</div>
              </div>
            </div>
            <div class="mt-10">
              <van-loading v-if="loading" vertical> 加载中... </van-loading>
            </div>
          </div>
        </div>
      </div>
       
      <div class="mx-3 h-1/3">
        <van-button type="primary" :loading="loading" block @click="onLoginDingTalk">钉钉登录</van-button>
        <!-- <van-button type="primary" :loading="loading" block @click="loginUserTwo">复制</van-button> -->
        <!-- <van-button type="primary" :loading="loading" block @click="loginUserOne">钉钉登录2</van-button> -->
        <div>{{ res }}</div>
      </div>

        <!-- <van-button type="primary" :loading="loading" block @click="loginUserOne">钉钉登录2</van-button> -->
        
        <!-- <van-button type="primary" :loading="loading" block @click="loginUserTwo">复制</van-button> -->
        <!-- <div> 1-{{ onLoginDingTalk1() }} </div> -->
        <!-- <div>2-{{ onLoginDingTalk2() }} </div> -->
        <div>3-{{ autoCode }}</div>
    </div>
</template>

<script>
    import {
        userLogin
    } from '@/api/dingDing/ddUser';
    import { Toast } from 'vant';
    import dd from 'dingtalk-jsapi';
    import localStorage from '@/util/storage';
    
    export default {
        name: 'UserLogin',
        data() {
            return {
                loading: false,
                showDingTalkLogin: false,
                tenantId: "847595",
                autoCode: '123',
                res: null,
            }
        },
        created() {
            // 加载缓存 tenantId
            this.tenantId = localStorage.getLocal("tenantId");
            this.checkDingTalk();
        },
        methods: { 
            checkDingTalk() {
              if (dd.env.platform !== 'notInDingTalk') {
                this.showDingTalkLogin = true;
                if (this.showDingTalkLogin) {
                  this.onLoginDingTalk();
                }
              } else {
                  this.$router.replace('/wage');
              }
            },
            onLoginDingTalk() {
                let that = this;
                dd.ready(() => {
                    dd.requestAuthCode({
                      corpId: 'ding317f4e197ec95e7535c2f4657eb6378f',
                      clientId: 'dingszvt2fzozw1ynwmk',
                      onSuccess: function (result) {
                        /*{
                            code: 'hYLK98jkf0m' //string authCode
                        }*/
                        that.autoCode = result.code;
                        that.loginUserOne();
                      },
                      onFail: function (err) {
                          Toast.fail("错误" + err);
                      },
                    });
                });
            },
            loginUserOne() {
                let getData = {
                    tenantId: this.tenantId,
                    authCode: this.autoCode,
                }
                userLogin(getData).then((res) => {
                    if (res.status == 200 && res.data.code == 200) {
                       this.res = res.data.data;
                       localStorage.saveLocal("userInfo", res.data.data);
                       // Toast.fail(localStorage.getLocal("userInfo"));
                       this.res = localStorage.getLocal("userInfo")
                       this.$router.replace('/wage');
                    }
                });
            },
            loginUserTwo() {
                const input = document.createElement('input');
                input.setAttribute('value', this.autoCode);
                document.body.appendChild(input);
                input.select();
                
                var successful = document.execCommand('copy');
                if(successful) {
                   Toast.success('复制成功'); 
                } else {
                   Toast.fail('复制失败');
                }
                document.body.removeChild(input);
            }
        }
    }
</script>

<style>
</style>